module.exports = __webpack_public_path__ + "img/gallery11.ec00e4b6.jpg";